import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

const useFetchAccountsBank = (token: string) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [accountsBank, setAccountsBank] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAccountBank = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const tk = await getAccessTokenSilently();

      const response = await axios.get<any>(
        `${apiUrl}/api/v1/accounts/user-accounts`,
        {
          headers: {
            Authorization: `Bearer ${tk}`,
            "Content-Type": "application/json",
          },
        }
      );
      setAccountsBank(response?.data);
    } catch (err) {
      console.error("Error fetching transactions:", err);
      setError("No se pudieron obtener las cuentas");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchAccountBank();
  }, [fetchAccountBank]);

  return { accountsBank, loading, error, refresh: fetchAccountBank };
};

export default useFetchAccountsBank;
